import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';

const Label = ({ label, icon, alt, className }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.icon}>
      {label && (
        <span className={cn({ [styles.marginLeft]: icon }, styles.label)}>
          {t(label)}
        </span>
      )}
      {icon && (
        <img className={cn(styles.image, className)} src={icon} alt={alt} />
      )}
    </div>
  );
};

Label.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default Label;
